import React from "react";
import Styles from "./CompanyDetails.module.css";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const DocumentDetails = ({ company, handlePreviewGeneralTerms }) => {
  return (
    <div className={`display_flex_column_gap_8 ${Styles.detailsContainer}`}>
      <div className={Styles.sectionHeader}>General Documents</div>
      <div className={Styles.detailRow}>
        <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
          <div>PAN Card</div>
          <div>
            {company?.companyDocumentMapping?.panDocId ? (
              <div
                className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
                onClick={() =>
                  handlePreviewGeneralTerms(
                    company?.companyDocumentMapping?.panDocId
                  )
                }
              >
                <span>View</span>
                <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
              </div>
            ) : (
              <>-</>
            )}
          </div>
        </div>
        <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
          <div>TAN</div>
          {company?.companyDocumentMapping?.tanDocId ? (
            <div
              onClick={() =>
                handlePreviewGeneralTerms(
                  company?.companyDocumentMapping?.tanDocId
                )
              }
              className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            >
              <span>View</span>
              <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
            </div>
          ) : (
            <>-</>
          )}
        </div>
        <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
          <div>GST</div>
          {company?.companyDocumentMapping?.gstDocId ? (
            <div
              onClick={() =>
                handlePreviewGeneralTerms(
                  company?.companyDocumentMapping?.gstDocId
                )
              }
              className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            >
              <span>View</span>
              <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
            </div>
          ) : (
            <>-</>
          )}
        </div>
        <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
          <div>Membership Form</div>
          {company?.companyDocumentMapping?.membershipFormDocId ? (
            <div
              onClick={() =>
                handlePreviewGeneralTerms(
                  company?.companyDocumentMapping?.membershipFormDocId
                )
              }
              className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            >
              <span>View</span>
              <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
            </div>
          ) : (
            <>-</>
          )}
        </div>
        <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
          <div>Trading Lisence</div>
          {company?.companyDocumentMapping?.tradingLicenseDocId ? (
            <div
              onClick={() =>
                handlePreviewGeneralTerms(
                  company?.companyDocumentMapping?.tradingLicenseDocId
                )
              }
              className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            >
              <span>View</span>
              <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
            </div>
          ) : (
            <>-</>
          )}
        </div>
        <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
          <div>Undertaking</div>
          {company?.companyDocumentMapping?.undertakingDocId ? (
            <div
              onClick={() =>
                handlePreviewGeneralTerms(
                  company?.companyDocumentMapping?.undertakingDocId
                )
              }
              className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            >
              <span>View</span>
              <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
            </div>
          ) : (
            <>-</>
          )}
        </div>
        <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
          <div>Proof of Payment</div>
          {company?.companyDocumentMapping?.proofOfPaymentDocId ? (
            <div
              onClick={() =>
                handlePreviewGeneralTerms(
                  company?.companyDocumentMapping?.proofOfPaymentDocId
                )
              }
              className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            >
              <span>View</span>
              <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
            </div>
          ) : (
            <>-</>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentDetails;
